// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__332SN","sendOtp":"AuthorizeToLogin_sendOtp__1VRKE"};